(function() {
    'use strict';
    var OutOfOfficeCtrl = function($scope, $compile, $uibModalInstance, ajaxCall, passedModel) {
        console.log("Inside OutOfOfficeCtrl");
        $scope.outOfOfficeModel = {};
        $scope.outOfOfficeModel.errorMessage = false;
        $scope.outOfOfficeModel.disableBtn = false;
        $scope.outOfOfficeModel.enableDisableLookupValId = '544';

        $scope.ajaxCallList = function(ajaxUrl, data) {
            var errorMsg = 'Error';
            ajaxCall.getData(ajaxUrl, data).then(function(result) {
                $scope.outOfOfficeModel.disableBtn = false;
                if (result.data == '544') { //enabled
                    $scope.outOfOfficeModel.result = true;
                } else if (result.data == '545') { //disabled
                    $scope.outOfOfficeModel.result = false;
                }
                $uibModalInstance.close($scope.outOfOfficeModel);
            }, function(result) {
                $scope.outOfOfficeModel.disableBtn = false;
                $scope.outOfOfficeModel.errorMessage = true;
                $scope.outOfOfficeModel.errorMessageVal = errorMsg;
            });
        }
        $scope.outOfOfficeSaveNg = function($event) {
            $event.preventDefault();
            $scope.outOfOfficeModel.disableAddBtn = true;
            var enableDisableLookupValId = $scope.outOfOfficeModel.enableDisableLookupValId;
            var person = $scope.outOfOfficeModel.person;
            var endDate = $scope.outOfOfficeModel.endDateFormatted;
            var endTime = $scope.outOfOfficeModel.endTimeTimeOnly;
            
            var data = 'enableDisableLookupValId=' + enableDisableLookupValId + '&person=' + person + '&endDate='+endDate+'&endTime='+endTime;
            var ajaxUrl = WEBAPP_PATH + "/outOfOffice/setOutOfOffice?";
            $scope.ajaxCallList(ajaxUrl + data);
        }
        $scope.closePop = function($event) {
            $uibModalInstance.close($scope.outOfOfficeModel);
        }
        $scope.cancel = function() {
            $uibModalInstance.close($scope.outOfOfficeModel);
        };
    }
    OutOfOfficeCtrl.$inject = ['$scope', '$compile', '$uibModalInstance', 'ajaxCall', 'params'];
    angular.module('app').controller('OutOfOfficeCtrl', OutOfOfficeCtrl);
}());
